<template>
    <div></div>
</template>

<script setup>
import { ref, provide, inject, reactive, watch, onBeforeMount } from 'vue';
import api from '@/api/base'


const model = reactive({});
const ready = ref(false);
let resolvePromise;

onBeforeMount(async () => {
    let tasks = [];
    let res = await api.get('/Enum/list');
    if (res?.data?.length > 0) {
        res.data.forEach((v) => {
            tasks.push(
                api.get(`/Enum/${v.name}`).then((v2) => {
                    model[v.name] = v2.data
                })
            )
        })
    }
    Promise.all(tasks)
        .then(results => {
            ready.value = true;
        })
})

watch(() => ready.value, async (nv, ov) => {
    if(nv == true) { 
        if (resolvePromise) {
            resolvePromise(model);
        }
    }
});

const r = {};
r.getAsync = async () => {
    if (ready.value) {
        return model;
    }

    return new Promise((resolve) => {
        resolvePromise = resolve;
    });
};

defineExpose(r);
</script>

<style scoped></style>
